var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{class:['swiper-container-'+_vm.mySwiperId]},[_c('v-uni-view',{ref:"swiperwrap",staticClass:"swiper-wrapper"},[_vm._t("default")],2)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }